import { render, staticRenderFns } from "./personal_data_tab.vue?vue&type=template&id=a0bf1704&scoped=true"
import script from "./personal_data_tab.vue?vue&type=script&lang=js"
export * from "./personal_data_tab.vue?vue&type=script&lang=js"
import style0 from "./personal_data_tab.vue?vue&type=style&index=0&id=a0bf1704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bf1704",
  null
  
)

export default component.exports